import { useRouterState } from '@tanstack/react-router';
import { m } from 'framer-motion';
import { cn } from '@/lib/utils';

/**
 * Indeterminate navigation progress bar — appears whenever the router is
 * pending (loaders running, lazy chunks fetching). Complements the optimistic
 * sidebar active state: the sidebar updates instantly on click, this bar signals
 * that work is still in flight.
 */
export function TopProgressBar() {
  const isPending = useRouterState({
    select: (s) => s.isLoading || s.status === 'pending',
  });

  return (
    <div
      role="progressbar"
      aria-hidden={!isPending}
      aria-label="Page loading"
      className={cn(
        'fixed inset-x-0 top-0 z-[9999] h-[2px] overflow-hidden pointer-events-none',
        'transition-opacity duration-150',
        isPending ? 'opacity-100' : 'opacity-0'
      )}
    >
      {isPending && (
        <m.div
          className="h-full w-1/3 bg-primary"
          initial={{ x: '-100%' }}
          animate={{ x: '400%' }}
          transition={{ repeat: Infinity, duration: 1.2, ease: 'easeInOut' }}
        />
      )}
    </div>
  );
}
